/**
 * Type guard function that checks if a value is null or undefined.
 * Returns true if the value is null or undefined, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is null or undefined, false otherwise
 *
 * @example
 * ```ts
 * import { IsNull } from "@pdfking/tfunc"
 *
 * const a = null;
 * const b = undefined;
 * const c = "hello";
 *
 * if (IsNull(a)) {
 *   // This block will execute
 * }
 *
 * if (IsNull(b)) {
 *   // This block will execute
 * }
 *
 * if (IsNull(c)) {
 *   // This block won't execute
 * }
 *
 * // Use in conditional logic
 * const value = IsNull(input) ? defaultValue : input;
 * ```
 */
export const IsNull = (value: unknown): value is null | undefined =>
  value == null
